import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { PhoneDialerNotificationInterface } from 'app/interface/phoneDialerNotificationInterface';
import { PhoneDialerNotificationBarComponent } from 'app/materials/phone-dialer-notification-bar/phone-dialer-notification-bar.component';
import { FormatPhoneNumberAs } from 'enumerations/format-phone-number-as';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private _snackBar: MatSnackBar) { }

  showError(message: string) {
    this._snackBar.open(message, "Dismiss");
  }

  showErrorContainingPhoneNumber({ 
    phoneNumber, 
    isoCountryCode, 
    formatAs, 
    prependMessage, 
    appendMessage, 
    dismissAfterPhoneDial 
  }: { 
    phoneNumber: string; 
    isoCountryCode: string; 
    formatAs: FormatPhoneNumberAs; 
    prependMessage: string; 
    appendMessage: string; 
    dismissAfterPhoneDial: boolean; 
  }): void {
      this._snackBar.openFromComponent(
        PhoneDialerNotificationBarComponent, {
          data: this.populatePhoneDialerNotificationData({ phoneNumber, isoCountryCode, formatAs, prependMessage, appendMessage, dismissAfterPhoneDial })
        });
  }

  showMessage(message: string): void {
    this._snackBar.open(message, "Dismiss", {
      panelClass: ['green-snackbar']
    });
  }

  private populatePhoneDialerNotificationData({ 
    phoneNumber, 
    isoCountryCode, 
    formatAs, 
    prependMessage, 
    appendMessage, 
    dismissAfterPhoneDial
  }: { 
    phoneNumber: string; 
    isoCountryCode: string; 
    formatAs: FormatPhoneNumberAs; 
    prependMessage: string; 
    appendMessage: string; 
    dismissAfterPhoneDial: boolean; 
  }): PhoneDialerNotificationInterface {
    let data: PhoneDialerNotificationInterface = {
      PhoneNumber: phoneNumber,
      IsoCountryCode: isoCountryCode,
      FormatAs: formatAs,
      PrependMessage: prependMessage,
      AppendMessage: appendMessage,
      DismissAfterPhoneDial: dismissAfterPhoneDial
    }
    return data;
  }
}
